import React from "react";
import { Link } from "react-router-dom";
import { FaUserTie } from "react-icons/fa";

const PesquisarDocumentos = () => {
  return (
    <div>
      <h1>PesquisarDocumentos</h1>
    </div>
  );
};

export default PesquisarDocumentos;
